<template>
  <v-dialog
    v-model="isActive"
    :max-width="290"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        ref="input"
        v-model="inputValue"
        :label="label"
        :prepend-icon="icon"
        :readonly="!clearable || readonly"
        :color="color"
        :class="inputClass"
        :hint="hint"
        :clearable="clearable"
        :persistent-hint="persistentHint"
        :disabled="disabled"
        :rules="validateRules()"
        :error-messages="errorMessages"
        :required="required"
        size="3"
        v-on="on"
      />
    </template>
    <v-date-picker
      ref="picker"
      v-model="parsedValue"
      size="5"
      :allowed-dates="isDateAllowed"
      :min="min"
      :max="max"
      :events="events"
      :event-color="eventColor"
      :picker-date="pickerDate"
      :readonly="readonly"
      scrollable
      actions
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="closePicker"
      >
        Done
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import moment from 'moment'

const dateFormat = 'YYYY-MM-DD'

export default {
  name: 'DatePicker',

  props: {
    offsetFrom: [String, Date],
    display: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    value: [String, Date, Number],
    inputClass: Object,
    color: String,
    persistentHint: Boolean,
    hint: String,
    label: String,
    clearable: Boolean,
    min: String,
    max: String,
    pickerDate: String,
    rules: {
      type: Array,
      default () {return []}
    },
    errorMessages: {
      type: Array,
      default () {return []}
    },
    icon: {
      type: String,
      default: 'mdi-calendar'
    },
    startDate: [String, Date],
    endDate: [String, Date],
    dayInterval: {
      type: Number,
      default: 1
    },
    allowedDates: Function,
    required: Boolean,
    events: [Function, Array, Object],
    eventColor: [Function, String, Object]
  },

  data () {
    return {
      isActive: false,
      pickerValue: null,
      momentStartDate: null,
      momentEndDate: null
    }
  },

  computed: {
    inputValue: {
      get () {
        return this.parsedValue
      },
      set (val) {
        if (!val) this.parsedValue = null
      }
    },
    parsedValue: {
      get () {
        if (this.offsetFrom || Number.isInteger(this.pickerValue)) {
          if (!this.offsetFrom) return undefined
          // offset from offsetDate
          // console.log('parseing offset', this.offsetFrom, this.pickerValue, moment(this.offsetFrom).subtract(this.pickerValue || 0, 'day').format('YYYY-MM-DD'))
          return moment(this.offsetFrom).subtract(this.pickerValue || 0, 'day').format('YYYY-MM-DD')
        }
        // Assume it's a string date?
        return this.pickerValue
      },
      set (val) {
        // if (!this.isActive) return
        console.log('setting picker', val, this.pickerValue)
        if (this.offsetFrom || Number.isInteger(this.value)) {
          // We need to return an offset
          // console.log('Setting picker offset', val, this.pickerValue, moment(this.offsetFrom).diff(moment(val), 'days'))
          this.pickerValue = moment(this.offsetFrom).diff(moment(val), 'days')
        } else {
          this.pickerValue = val
        }
      }
    }
  },

  watch: {
    offsetFrom (offset) {
      // Force value to recalculate from offset time if it changes
      this.pickerValue = this.value
    },
    value (val) {
      if (this.pickerValue !== val) this.pickerValue = val
    },
    display (val) {
      if (this.disabled || this.readonly || this.isActive === val) return
      this.isActive = val
    },
    disabled (val) {
      if (val) {
        this.isActive = false
      }
    },
    isActive (val) {
      const picker = this.$refs.picker
      if (!val && picker) {
        // picker.inputDate = picker.originalDate
      }
      this.$refs.input.validate(true)
    },
    pickerValue (val, old) {
      if (this.value !== val) {
        console.log('Value changed', val, old, this.value)
        const picker = this.$refs.picker
        if (picker) picker.originalDate = this.parsedValue
        this.$emit('input', val)
      }
      this.isActive = false
    }
  },
  mounted () {
    this.pickerValue = this.value
    this.momentStartDate = this.startDate ? moment(moment(this.startDate).format(dateFormat)) : null
    this.momentEndDate = this.endDate ? moment(moment(this.endDate).format(dateFormat)) : null
    this.isActive = !this.readonly && !this.disabled && !!this.display
  },
  methods: {
    isDateAllowed (val) {
      var defaultResult = true
      if (typeof this.allowedDates === 'function') {
        // console.log('Call allowed date')
        // var t0 = performance.now()
        defaultResult = this.allowedDates(val)
        // var t1 = performance.now()
        // console.log('Done call allowed date: ' + (t1 - t0) + ' milliseconds.')
      }
      if (!defaultResult) return defaultResult
      return (val) => {
        if (!this.momentStartDate && !this.momentEndDate) return defaultResult
        /**
         * TODO:  cache start, end and selectedDate for increased performance
         */
        var start = this.momentStartDate
        var end = this.momentEndDat
        var date = moment(moment(val).format(dateFormat))
        var fromStart = date.diff(start, 'days')
        var fromEnd = end.diff(date, 'days')
        var result = fromStart % this.dayInterval === 0 & fromStart >= 0 && fromEnd >= 0
        // console.log('checking', date.format(dateFormat), start.format(dateFormat), end.format(dateFormat), fromStart, fromEnd, result)
        if (!result && moment(moment(this.parsedValue || undefined).format(dateFormat)).isSame(date)) {
          return defaultResult // always allow selecting currently selected date
        }
        return result
      }
    },
    closePicker () {
      this.isActive = false
    },
    validateRules () {
      return [
        (v) => {
          if (this.isActive) return true
          if (this.rules) {
            for (let rule of this.rules) {
              var result = rule(v)
              if (result !== true) return result
            }
            return true
          }
        }
      ]
    }
  }
}
</script>
